MainTable = new (function () {
  let wrapper;

  this.buildChart = (chartContainerId, formData) => {
    MainTable.dataSubject = [["Year", "Actual result", "Expected result", "Target result", "min"]];
    let id = $("#" + chartContainerId).data("id");
    formData.push({ name: "filter[student_id]", value: id });
    $.ajax({
      type: "GET",
      url: "/",
      data: $.param(formData),
      contentType: "application/json; charset=utf-8",
      dataType: "json",
      success: function (data) {
        let objects = data.objects;
        let isSubjectsShown = data.subjects_shown;
        if (Array.isArray(objects) && objects.length > 0) {
          Shared.drawStudentChart({
            objects,
            isSubjectsShown,
            containerElementId: chartContainerId,
            legendElementId: "legendId" + id,
          });
          $("#" + chartContainerId)
            .prev()
            .show();
        }
      },
      error: function (data) {
        console.log(data.errors);
      },
    });
  };

  this.hideVisibleExams = () => {
    $("body").on("click", ".col_checkbox", function (event) {
      let dataCol = [];
      let ndx = $(this).parent().index() + 1;

      dataCol.push($(`table tr.bottom th:nth-child(${ndx})`).data("value"));

      for (var i in dataCol) {
        $("#main_filter_form").append(
          `<input type="hidden" name="filter[individual_result][]" value="${dataCol[i]}" class="filter_individual_result"/>`
        );
      }

      $("#main_filter_form").submit();
    });

    $(document).ajaxComplete(function () {
      $(".btn__show_col").on("click", function (e) {
        e.preventDefault();
        $(".filter_individual_result").remove();
        $("#main_filter_form").submit();
      });
    });
  };

  this.initTable = () => {
    const wrapperSelector = ".search-results-wrapper";
    wrapper = document.querySelector(wrapperSelector);

    if (!wrapper) return;

    Shared.bindExpandRowEvent(wrapperSelector, "#main_filter_form", this.buildChart);
    this.hideVisibleExams();
  };
})();
